module.exports = __webpack_public_path__ + "static/not-selected.800eabde.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/not-selected.png
// module id = 1030
// module chunks = 2